export default __webpack_public_path__ + "static/media/Success.cd60fc73.svg";